export enum AppRoutes {
  ROOT = "root",
  DASHBOARD = "dashboard",
  SIGN_IN = "sign-in",
  VERIFY_OTP = "verify-otp",
  INVITE_USER = "invite-user",
  IMPORT_USERS = "import-users",
  CRITERIA_LOGS = "criteria-logs",
  AI_LOGS = "ai-logs",
  AUTH_LOGS = "auth-logs",
  AI_EVALS = "ai-evals",
  AI_EVALS_CLAIMS = "ai-evals-claims",
  AI_EVALS_CHAT = "ai-evals-chat",
  AI_EVALS_INTELLIGENCE = "ai-evals-intelligence",
  USER_SETTINGS = "user-settings",
  GLOBAL_SETTINGS = "global-settings",
  ORGANIZATIONS = "organizations",
  TEMPLATES = "templates",
  DEFICIENCIES = "deficiencies",
  PROMPTS = "prompts",
  PROMPTS_FEATURE = "prompts-feature",
  FEATURE_FLAGS = "feature-flags"
}

export const getRouteDashboard = () => `/${AppRoutes.DASHBOARD}`;
export const getRouteSignIn = () => `/${AppRoutes.SIGN_IN}`;
export const getRouteVerifyOtp = () => `/${AppRoutes.VERIFY_OTP}`;
export const getRouteInviteUser = () => `/${AppRoutes.INVITE_USER}`;
export const getRouteImportUsers = () => `/${AppRoutes.IMPORT_USERS}`;
export const getRouteCriteriaLogs = () => `/${AppRoutes.CRITERIA_LOGS}`;
export const geRouteAiLogs = () => `/${AppRoutes.AI_LOGS}`;
export const getRouteAuthLogs = () => `/${AppRoutes.AUTH_LOGS}`;
export const getRouteAiEvals = () => `/${AppRoutes.AI_EVALS}`;
export const getRouteAiEvalsClaims = () => `/${AppRoutes.AI_EVALS}/claims-extraction`;
export const getRouteAiEvalsChat = () => `/${AppRoutes.AI_EVALS}/chat-response`;
export const getRouteAiEvalsIntelligence = () => `/${AppRoutes.AI_EVALS}/intelligence-questions`;
export const getRouteUserSettings = () => `/${AppRoutes.USER_SETTINGS}`;
export const getRouteGlobalSettings = () => `/${AppRoutes.GLOBAL_SETTINGS}`;
export const getRouteOrganizations = () => `/${AppRoutes.ORGANIZATIONS}`;
export const getRouteTemplates = () => `/${AppRoutes.TEMPLATES}`;
export const getRouteDeficiencies = () => `/${AppRoutes.DEFICIENCIES}`;
export const getRoutePrompts = () => `/${AppRoutes.PROMPTS}`;
export const getRoutePromptsFeature = (featureKey: string) => `/${AppRoutes.PROMPTS}/${featureKey}`;
export const getRoutePromptsRevision = (featureKey: string, revisionId: number) =>
  `/${AppRoutes.PROMPTS}/${featureKey}/revisions/${revisionId}`;
export const getRoutePromptTestCases = (featureKey: string, fromRevisionId?: number) =>
  `/${AppRoutes.PROMPTS}/${featureKey}/test-cases${fromRevisionId ? `?fromRevision=${fromRevisionId}` : ""}`;
export const getRoutePromptComparison = (featureKey: string, revisionId: number, comparisonId: number) =>
  `/${AppRoutes.PROMPTS}/${featureKey}/revisions/${revisionId}/tests/${comparisonId}`;
export const getRouteFeatureFlags = () => `/${AppRoutes.FEATURE_FLAGS}`;
